import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { LibraryView } from '@/features/reader/components/LibraryView';

export const Route = createFileRoute('/library')({
  component: LibraryPage,
});

function LibraryPage() {
  return (
    <AuthGuard>
      <LibraryView />
    </AuthGuard>
  );
}
